import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import { measureDrawArea, measureDrawLength } from '@/ol/interactions';
import { measureDrawLayer } from '@/ol/layers';
import { isDrawingState } from '@/store';

export default function Measures({ map }) {
  const [isDrawing, setIsDrawing] = useAtom(isDrawingState);

  const toggleDraw = (draw, active) => {
    if (draw.getActive() !== active) {
      draw.setActive(active);
    }
  };

  const activateMeasure = (draw) => {
    if (draw === measureDrawLength) {
      toggleDraw(measureDrawLength, true);
      toggleDraw(measureDrawArea, false);
    } else {
      toggleDraw(measureDrawLength, false);
      toggleDraw(measureDrawArea, true);
    }

    setIsDrawing(true);
  };

  useEffect(() => {
    if (!isDrawing) {
      toggleDraw(measureDrawArea, false);
      toggleDraw(measureDrawLength, false);

      measureDrawLayer.getSource().clear();
      map.getOverlays().clear();
    }
  });

  return (
    <Stack spacing={1}>
      <Paper elevation={4}>
        <Button
          sx={{ width: '100%' }}
          color="secondary"
          onClick={() => {
            activateMeasure(measureDrawLength);
          }}
        >
          Longueur
        </Button>
      </Paper>
      <Paper elevation={4}>
        <Button
          sx={{ width: '100%' }}
          color="secondary"
          onClick={() => {
            activateMeasure(measureDrawArea);
          }}
        >
          Surface
        </Button>
      </Paper>
    </Stack>
  );
}

Measures.propTypes = {
  map: PropTypes.object.isRequired,
};
